import { IPaginatedRequest, IPaginatedRequestWholsaler } from '@cbgms/api/request'
export interface FormattedModule {
  AppId: string
  IsBasePackage: boolean
  IsSearchFilter: boolean
  ModuleId: string
  ModuleName: string
  ModuleStoreFlag: number | null
  TopMotiveFlag: number
}
export interface Email {
  Email: string
  Origin: string
  IsPrimary: boolean
}
export interface FormattedDatas {
  Modules: FormattedModule[]
}
export const listCustomers = (params: IPaginatedRequest, role: string, emailAddress: string, appId: string | undefined) => {
  if (role !== 'dach_telesales') {
    return {
      method: 'GET',
      url: `/modules/customers?AppId=${appId}`,
      params
    }
  } else {
    return {
      method: 'GET',
      url: `/modules/customers?SalesRep=${emailAddress}&AppId=${appId}`,
      params
    }
  }
}

export const customerPendingLogRequest = (params: IPaginatedRequest) => {
  const { appid, search, ...restParams } = params
  const appIdSearch = appid ? `PendingLogsOutput.AppId|=|${appid}` : ''
  const searchQuery = [appIdSearch, search].filter(Boolean).join(',')

  return {
    method: 'GET',
    url: '/modules/email/pendinglogs/list',
    params: {
      ...restParams,
      search: searchQuery
    }
  }
}

export const wholesalerTamplateListRequest = (params: IPaginatedRequestWholsaler) => {
  return {
    method: 'GET',
    url: '/modules/wholesaler-forms',
    params: {
      ...params
    }
  }
}

export const logsRequest = (params: IPaginatedRequest) => {
  return {
    method: 'GET',
    url: `/modules/customers/logs`,
    params
  }
}

export const searchUserRequest = (data: any) => ({
  method: 'POST',
  url: '/modules/customers/search',
  data
})

export const searchPendingLogRequest = (data: object) => ({
  method: 'POST',
  url: '/modules/email/pendinglogs/search',
  data
})

export const resendRequest = (data: object) => ({
  method: 'POST',
  url: '/modules/email/resend',
  data
})

export const resetUserRequest = (data: object) => ({
  method: 'POST',
  url: '/modules/customers/resetuser',
  data
})

export const resendAllRequest = (data: string) => ({
  method: 'POST',
  url: `/modules/email/resend/all/${data}`
})

export const deletePendingEmailRequest = (data: string) => ({
  method: 'DELETE',
  url: `/modules/email/pendinglogs/delete/${data}`
})

export const getConceptsRequest = (appId: number) => ({
  method: 'GET',
  url: `/modules/customers/lov/modules/${appId}`
})

export const reimportConceptsRequest = (
  appId: string,
  customerEosId: string,
  customerNumber: string,
  shipToLocation: string,
  OuName: string,
  userEmail: string
) => ({
  method: 'POST',
  url: `/modules/customers/eos/refresh`,
  data: {
    AppId: appId,
    CustomerEosId: customerEosId,
    CustNo: customerNumber,
    ShipToLoc: shipToLocation,
    OuName,
    SalesRepEmail: userEmail
  }
})

export const getDeliveryRequest = (CustNo: string, ShipToLoc: string, OuName: string, AppId: string, CustomerEosId: string) => ({
  method: 'POST',
  url: `/modules/customers/delivery`,
  data: {
    CustNo,
    ShipToLoc,
    OuName,
    AppId,
    CustomerEosId
  }
})

export const checkPreconditionStatusRequest = (data: any) => ({
  method: 'POST',
  url: '/modules/customers/precondition',
  data
})

export const checkFetchCustomerEmails = (custEosId: string) => ({
  method: 'GET',
  url: `/modules/customers/${custEosId}/emails`
})

export const checkRemoveCustomerEmail = (custEosId: string, updatedEmails: any, App_Id: number) => ({
  method: 'POST',
  url: `/modules/customers/${custEosId}/emails`,
  data: { CustomerEmails: JSON.stringify(updatedEmails), AppId: App_Id }
})

export const checkConfirmCustomerEmails = (custEosId: string, emails: any, App_Id: number) => ({
  method: 'POST',
  url: `/modules/customers/${custEosId}/emails`,
  data: { CustomerEmails: JSON.stringify(emails), AppId: App_Id }
})

export const checkAddCustomerEmail = (custEosId: string, newEmails: Email[], App_Id: number) => ({
  method: 'POST',
  url: `/modules/customers/${custEosId}/emails`,
  data: {
    CustomerEmails: JSON.stringify(newEmails),
    AppId: App_Id
  }
})
export const requestFetchModulesCalled = (ouName: string) => ({
  method: 'GET',
  url: `/modules/modules/${ouName}`
})

export const requestModulesSave = (formattedData: FormattedDatas) => ({
  method: 'PUT',
  url: '/modules/modules',
  data: formattedData
})

export const fetchEcommDataRequest = ({ CustEosID, OuName, AppId }: { CustEosID: string; OuName: string; AppId: string }) => ({
  method: 'POST',
  url: '/modules/conceptmanagement/ecomm/info',
  data: { CustEosID, OuName, AppId }
})

export const fetchCustomerProfileDataRequest = (CustEosID: string) => ({
  method: 'GET',
  url: `/modules/customers/${CustEosID}`
})

export const fetchConceptsRequest = ({ CustEosID, OuName, AppId }: { CustEosID: string; OuName: string; AppId: string }) => ({
  method: 'POST',
  url: '/modules/customers/concepts',
  data: { CustEosID, OuName, AppId }
})

export const fetchContractsRequest = ({ CustEosId, AppId }: { CustEosId: string; AppId: string }) => ({
  method: 'GET',
  url: `/modules/customers/contracts?CustEosId=${CustEosId}&AppId=${AppId}`
})

export const fetchEcomPackagesRequest = (customerNumber: string, App_Id: string, ou_name: string) => ({
  method: 'GET',
  url: `/modules/subscriptions/getBasicPackages?OuName=${ou_name}&AppId=${App_Id}&CustEosId=${customerNumber}`
})

export const sendConfirmationRequest = (orderRequestBody: any) => ({
  method: 'POST',
  url: '/modules/customers/sendConfirmation',
  data: orderRequestBody
})
export const requestFetchConcepts = (custEosId: string, appId: any) => ({
  method: 'GET',
  url: '/modules/customers/modules',
  params: {
    custEosId,
    appId
  }
})

export const requestSaveConcepts = (changedModules: any) => ({
  method: 'PUT',
  url: '/modules/customers/modules',
  data: changedModules
})

export const resendLinkRequest = (custNo: string, shipToLoc: string, salesRepEmail: string, appId: number, CustomerEosId: string) => ({
  method: 'POST',
  url: '/modules/customers/resendLink',
  data: { custNo, shipToLoc, salesRepEmail, appId, CustomerEosId }
})

export const resendLinkStatusCheck = (custEosid: string, appId: number) => ({
  method: 'GET',
  url: `/modules/customers/${custEosid}/status/${appId}`
})

export const emailTemplatesRequest = (App_Id: string) => ({
  method: 'GET',
  url: `modules/email/template?AppId=${App_Id}`
})

export const emailContentRequest = (emailTemplateUUID: string) => ({
  method: 'GET',
  url: `modules/email/template/${emailTemplateUUID}`
})

export const emailContentModificationRequest = (requestBody: object) => ({
  method: 'PUT',
  url: 'modules/email/template',
  data: requestBody
})

export const fetchAttachmentRequest = (App_Id: string) => ({
  method: 'GET',
  url: `modules/email/attachment?AppId=${App_Id}`
})

export const fetchReceiverEmailRequest = (data: string) => ({
  method: 'GET',
  url: `/modules/email/pendinglogs/getlist/${data}`
})

export const requestFetchOffers = (appId: string) => ({
  method: 'GET',
  url: `/modules/articleoffers/${appId}`
})

export const requestFetchArticles = (appId: string, articleOfferUuid: string) => ({
  method: 'GET',
  url: `/modules/articleoffers/${articleOfferUuid}/articlelist/${appId}`
})

export const fetchAlertMessageRequest = (status: string, appId: string) => ({
  method: 'GET',
  url: `/modules/alertmessages?AppId=${appId}&Status=${status}`
})

export const AddEditAlertMessageRequest = (alertMessageData: any) => ({
  method: 'POST',
  url: '/modules/alertmessages',
  data: alertMessageData
})
export const deleteAlertMessageRequest = (messeseId: string) => ({
  method: 'DELETE',
  url: `modules/alertmessages/${messeseId}`
})

interface ArticleOfferPayload {
  ArticleOfferUUId: string
  OfferDescription: string
  ValidForConcepts: string
  ValidFrom: string
  ValidTo: string
  MixFile: boolean
  MixingFromPosition: string
  File?: File | undefined
}

const handleFormData = (appId: string, payload: ArticleOfferPayload, createdByName: string, updatedByName: string) => {
  const formData = new FormData()
  formData.append('app_id', appId)
  formData.append('description', payload.OfferDescription)
  formData.append('criteria_concept', payload.ValidForConcepts)
  formData.append('valid_from', payload.ValidFrom)
  formData.append('valid_to', payload.ValidTo)
  formData.append('mix_up', payload.MixFile.toString())
  formData.append('mix_from', payload.MixingFromPosition)
  formData.append('created_by_name', createdByName)
  formData.append('updated_by_name', updatedByName)
  if (payload.File === undefined || payload.File === null) {
    formData.append('file', '')
  } else {
    formData.append('file', payload.File)
  }
  return formData
}

export const addArticleOfferRequest = (appId: string, payload: ArticleOfferPayload, createdByName: string, updatedByName: string) => {
  const formDataResponse = handleFormData(appId, payload, createdByName, updatedByName)
  return { method: 'POST', url: `/modules/articleoffers/create`, data: formDataResponse }
}

export const editArticleOfferRequest = (appId: string, payload: ArticleOfferPayload, createdByName: string, updatedByName: string) => {
  const formDataResponse = handleFormData(appId, payload, createdByName, updatedByName)
  return { method: 'PUT', url: `/modules/articleoffers/edit/${payload.ArticleOfferUUId}`, data: formDataResponse }
}

export const deleteArticleOfferRequest = (articleOfferUuid: string) => ({
  method: 'DELETE',
  url: `/modules/articleoffers/delete/${articleOfferUuid}`
})

export const fetchAllWholesalerListRequest = () => ({
  method: 'GET',
  url: '/modules/wholesaler-forms/wholesalerlist'
})

export const fetchTemplateListRequest = (wholesalerUUID: string) => ({
  method: 'GET',
  url: `/modules/wholesaler-forms/${wholesalerUUID}/templatelist`
})

export const fetchFormDataRequest = (formDataUUID: string) => ({
  method: 'GET',
  url: `/modules/wholesaler-forms/${formDataUUID}`
})

export const downloadCsvFileRequest = (selectedWholesaler: string, selectedTemplate: string) => ({
  method: 'GET',
  url: `/modules/wholesaler-forms/export/${selectedWholesaler}/${selectedTemplate}`
})
